import React from 'react';
import Login from './auth/Login';
import Register from './auth/Register';
import Lobby from './Lobby';
import GameBoard from './GameBoard';
import PlayerDashboard from './PlayerDashboard';
import { PlayerData, CardData, VikingData, GameState } from '../types/GameTypes';

type AppState = 'login' | 'register' | 'menu' | 'in_queue' | 'in_lobby' | 'in_game';

interface ContentRendererProps {
  appState: AppState;
  playerId: string | null;
  gameId: string | null;
  lobbyPlayers: any[];
  gameState: GameState | null;
  marketCards: CardData[];
  onLoginSuccess: (token: string) => void;
  onRegisterSuccess: () => void;
  onLogout: () => void;
  onFindGame: () => void;
  onCancelFindGame: () => void;
  onPlayCard: (cardId: string) => void;
  onHeal: () => void;
  setAppState: (state: AppState) => void;
}

const ContentRenderer: React.FC<ContentRendererProps> = ({
  appState,
  playerId,
  gameId,
  lobbyPlayers,
  gameState,
  marketCards,
  onLoginSuccess,
  onRegisterSuccess,
  onLogout,
  onFindGame,
  onCancelFindGame,
  onPlayCard,
  onHeal,
  setAppState,
}) => {
  switch (appState) {
    case 'login':
      return (
        <>
          <Login onLoginSuccess={onLoginSuccess} />
          <p>Don't have an account? <button onClick={() => setAppState('register')}>Register</button></p>
        </>
      );
    case 'register':
      return (
        <>
          <Register onRegisterSuccess={onRegisterSuccess} />
          <p>Already have an account? <button onClick={() => setAppState('login')}>Login</button></p>
        </>
      );
    case 'menu':
      return (
        <div className="main-menu">
          <button onClick={onLogout}>Logout</button>
          <button onClick={onFindGame} className="find-game-button">Find Game</button>
        </div>
      );
    case 'in_queue':
      return (
        <div className="queue-status">
          <p>Searching for game...</p>
          <button onClick={onCancelFindGame} className="cancel-button">Cancel</button>
        </div>
      );
    case 'in_lobby':
      return <Lobby initialPlayers={lobbyPlayers} gameId={gameId} />;
    case 'in_game':
      if (!gameState || !playerId) return <div>Loading Game...</div>;
      
      // Find the current player's viking data
      const currentViking = gameState.players.find((p: VikingData) => p.playerId === playerId);
      
      const selfData: PlayerData | undefined = currentViking 
        ? { 
            viking: currentViking, 
            hand: [], 
            deckCount: 0, 
            discardCount: 0 
          } 
        : undefined;
      
      return (
        <div className="game-view">
          <GameBoard gameId={gameState.id} localPlayerId={playerId} onPlayCard={onPlayCard} />
          {selfData && (
            <PlayerDashboard 
              player={selfData} 
              onPlayCard={onPlayCard} 
              marketCards={marketCards} 
              onHeal={onHeal} 
            />
          )}
        </div>
      );
    default:
      return null;
  }
};

export default ContentRenderer;